module.exports = __webpack_public_path__ + "img/news-11.cfcf4e3a.png";